import { render, staticRenderFns } from "./PromotionPopup.vue?vue&type=template&id=405d7ca1&scoped=true"
import script from "./PromotionPopup.vue?vue&type=script&lang=js"
export * from "./PromotionPopup.vue?vue&type=script&lang=js"
import style0 from "./PromotionPopup.vue?vue&type=style&index=0&id=405d7ca1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d7ca1",
  null
  
)

export default component.exports